import clsx from "clsx";

const Logo = () => {
  return (
    // <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     d="M29.5033 0.00170898L43.3717 43.3752H35.57L21.6868 0.00170898H29.5033ZM1.14441e-05 43.3752H7.80353L21.6868 0.00170898H13.8647L1.14441e-05 43.3752Z"
    //     fill="currentColor"
    //     className={clsx("transition-colors")}
    //   />
    // </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M48 0L0 0L0 48H29.1808H33.3844H38.8144H48V0Z" fill="#111111"/>
      <path d="M23.6381 11.7202L31.4878 36.2784H27.0634L19.2136 11.7202L11.3639 36.2784H6.93945L14.7892 11.7202H19.2136H23.6381Z" fill="white"/>
      <path d="M41.0613 36.2784L33.2115 11.7202H28.7871L36.6369 36.2784H41.0613Z" fill="white"/>
    </svg>
  );
};

export default Logo;
